





























import VirtualList from 'vue-virtual-scroll-list';
import { computed, defineComponent, PropType, toRefs, ref, onMounted, onUnmounted } from '@vue/composition-api';
import { AcoFormData, FullNormalFormData, IdentityOptionList } from '@tt4b/ttam-enums';
import SelectNoDataIcon from '@tt4b/ttam-assets/src/svgs/select-no-data.svg';
import ListItem from '../../common-tiktok-list/list-item.vue';
import { useIdentityPageList } from '../../hooks/use-identity-page-list';
import { getDeliveryIdentityType } from '@tt4b/ttam-utils';

const name = 'ttam-delivery-tiktok-identity-list';
export default defineComponent({
  name,
  components: {
    VirtualList,
    SelectNoDataIcon,
  },
  props: {
    creativeData: {
      type: Object as PropType<FullNormalFormData & AcoFormData>,
      default: () => ({}),
    },
    genListOptionsFunction: {
      type: Function,
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      default: () => {},
    },
  },
  setup(props, { emit }) {
    const { creativeData } = toRefs(props);

    const curIdentityData = computed(() => creativeData.value?.identityData || {});
    const curIdentityAuthId = computed(() => creativeData.value?.identityAuthId || '');
    const curIdentityBcId = computed(() => creativeData.value?.identityBcId || '');
    const curIdentityType = computed(() => creativeData.value?.identityType || 1);

    /** 列表 start */
    const dataList = ref<IdentityOptionList[]>([]);
    const isEmpty = computed(() => !dataList.value?.length);

    const { page, hasMore, loading, handleLoad, resetPageList } = useIdentityPageList({
      identityType: getDeliveryIdentityType(curIdentityType.value),
      identityAuthId: curIdentityAuthId.value,
      identityBcId: curIdentityBcId.value?.toString(),
      genListOptionsFunction: props.genListOptionsFunction,
    });

    const onScrollBottom = () => {
      if (loading.value) {
        return;
      }

      if (hasMore.value) {
        page.value += 1;

        handleLoad().then((data = []) => {
          dataList.value = dataList.value.concat(data);
        });
      }
    };

    // 选中对象
    const onClick = data => {
      emit('change', data);
    };

    /**
     * 点击展开下拉列表时会渲染该组件
     * 作用：拉取列表第一页的数据
     */
    onMounted(() => {
      if (loading.value) {
        return;
      }

      handleLoad().then((data = []) => {
        dataList.value = dataList.value.concat(data);
      });
    });
    /** 列表 end */

    onUnmounted(() => {
      resetPageList();
    });

    return {
      name,
      isEmpty,
      loading,
      dataList,
      curIdentityData,
      ListItem,

      onClick,
      onScrollBottom,
    };
  },
});
